// extracted by mini-css-extract-plugin
module.exports = {"content":"ProductCardContainer_content__Q3fMD"};